// Derived Data Fields

export {GuidDataFieldInterface, GuidDataFieldClass} from './guid.model';

export {
  RevisionDataFieldClass,
  RevisionDataFieldInterface
} from './revision.model';

export {VrsnDataFieldClass, VrsnDataFieldInterface} from './vrsn.model';

export {StatusDataFieldClass, StatusDataFieldInterface} from './status.model';

export {
  NamespaceDataFieldClass,
  NamespaceDataFieldInterface
} from './namespace.model';

export {
  EmailAddressDataFieldClass,
  EmailAddressDataFieldInterface
} from './email-address.model';

export {
  CurrencyCodeDataFieldClass,
  CurrencyCodeDataFieldInterface
} from './currency-code.model';

export {
  MoneyDatatypeClass,
  MoneyDatatypeInterface
} from './money-datatype.model';
